THEME.single = {
  init: function() {

    /* ================================
    ===     SET POST VIEW          ====
    =================================== */
    function common_theme_single(){
      if (!post_view_child('.meta.fb-share').data('do')) {
        post_view_child('.meta.fb-share').data('do', 1);
      }
      $themeMain.find('article.article--single').removeClass('article--viewing');
      $post_view.addClass('article--viewing');
      theme_clone_all();

      is_scrolling_to = false;

      if (viewing_text !== null) {
        $themeStripBar.find('.strip-bar--progress').hide();
      }
    }
    function init_theme_single($element){
      $post_view = $element;
      
      common_theme_single();

      add_ads_theme_single(post_view_child('.inner-article.add'),post_view_child('.theme-adv.af'));
    }

    /* ================================
    ===  Scroll to next/prev post  ====
    =================================== */
    function theme_scroll_to_next_article($is_this_post_view) {
      if (false !== $post_view) {
        $themeHtmlBody.stop().clearQueue();
        is_scrolling_to_next_post = $post_view.next();
        var scroll_to_next_prev_post = 0;
        if($is_this_post_view){
          scroll_to_next_prev_post = theme_get_offset_top($post_view) - $themeStripBarFixed.height() +2;
        } else if ($post_view.next().length > 0) {
          scroll_to_next_prev_post = theme_get_offset_top($post_view.next()) - $themeStripBarFixed.height() + 2;
        } else {
          is_scrolling_to_next_post = jQuery('footer#footer');
          scroll_to_next_prev_post = theme_get_offset_top(is_scrolling_to_next_post) - $themeStripBarFixed.height() + 10;
        }

        theme_status_lazy_load();
        $themeHtmlBody.animate({
          scrollTop: scroll_to_next_prev_post
        }, 1000, "swing", function(){
            $themeHtmlBody.stop().clearQueue();
            theme_status_lazy_load();
            $themeWin.trigger("scroll");
        });

      }
    }

    function theme_scroll_to_prev_article(time) {
      if (false !== $post_view) {
        $themeHtmlBody.stop().clearQueue();
        is_scrolling_to_prev_post = $post_view;

        var document_top = 0;
        document_top = parseInt(themeDocTop + $themeStripBarFixed.height() - 1);

        var add_first_article=0;
        if(!is_scrolling_to_prev_post.hasClass('article--next')){
          add_first_article = 10;
        }
        if (theme_get_offset_top(is_scrolling_to_prev_post) === document_top+add_first_article) {
          if ($post_view.prev().length > 0) {
            is_scrolling_to_prev_post = $post_view.prev();
          } else {
            is_scrolling_to_prev_post = $themeHtml;
          }
        }

        if(!is_scrolling_to_prev_post.hasClass('article--next')){
          add_first_article = 10;
        }
        var scroll_to_next_prev_post = 0;
        scroll_to_next_prev_post = theme_get_offset_top(is_scrolling_to_prev_post) - add_first_article - $themeStripBarFixed.height() + 1;
        theme_status_lazy_load();
        $themeHtmlBody.animate({
          scrollTop: scroll_to_next_prev_post
        }, time, "swing", function() {
          $themeHtmlBody.stop().clearQueue();
          is_scrolling_to_next_post = false;
          is_scrolling_to_prev_post = false;
          theme_status_lazy_load();
          $themeWin.trigger("scroll");
        });
      }
    }

    function click_cta_next(e){
      e.preventDefault();
      e.stopPropagation();
      is_scrolling_to_prev_post = false;
      is_scrolling_to_next_post = false;
      $themeHtmlBody.stop().clearQueue();
      theme_scroll_to_next_article(false);
    }

    function click_cta_prev(e){
      e.preventDefault();
      e.stopPropagation();
      is_scrolling_to_prev_post = false;
      is_scrolling_to_next_post = false;
      $themeHtmlBody.stop().clearQueue();
      theme_scroll_to_prev_article(1000);
    }

    /* ================================
    ===       CONTENT              ====
    =================================== */
    function strip_bar__progress() {
      $el = $themeStripBar.find('.strip-bar--progress');
      if($el.length){
        var percentage = ((singleOffsetTop - theme_get_offset_top($post_view)) * 100 / $post_view.outerHeight());
        if (percentage <= 0)  {  percentage = 0; }
        if (percentage >= 100)  { percentage = 100; }
        $el.css('width', percentage + "%").show();
      }
    } /* strip bar progress */

    function theme_change_article(document_title,link,multipage) {
      if (document.title !== document_title) {
        theme_change_title_and_url(document_title,link);
        if(!multipage){
          $themeStripBarSingle
            .find('.strip-bar__content .strip-bar__text').find('.strip-bar__text--title')
            .html("")
            .append(decodeHtml(post_info[post_viewing].title.rendered)).text();

          $themeStripBarSingle.find('.strip-bar__content .btn--facebook')
            .data("title", document_title)
            .attr("data-title", document_title)
            .data("href", post_info[post_viewing].link.share)
            .attr("data-href", post_info[post_viewing].link.share);

          if (false !== is_scrolling_to_next_post) {
            theme_scroll_to_next_article(true);
          }

        }
        theme_change_article_end();
        console.log(viewing_text);
      }
    } /* set document.title,etc when change article */

    function theme_elaborate_article() {
      position_load_pagination = false;
      position_load_feed = false;
      position_load_next_post = false;
      var post_number = 0;
      $themeMain.find('article.article--single', this).each(function() {

        var $element = jQuery(this);

        post_number++;
        var if1 = (post_number > 1 && singleOffsetTop >= theme_get_offset_top($element) && singleOffsetTop <= (theme_get_offset_top($element) + $element.outerHeight()));
        var if2 = (post_number <= 1 && singleOffsetTop <= (theme_get_offset_top($element) + $element.outerHeight()));
        
        if (if1 || if2) {

          $post_view = $element;
          if (POST.infinite_loops_single_pagination) {
            if (!theme_is_mobile() && !theme_has_class(post_view_child('.article--multipage-loader'),"showed")) {
              post_view_child('.article--multipage-loader').show().addClass('showed');
            }
          }

          var multipage_loader_height=post_view_child('.article--multipage-loader').length? post_view_child('.article--multipage-loader').outerHeight() : 0;
          if(isNaN(multipage_loader_height)){multipage_loader_height=0;}

          position_load_pagination = theme_get_offset_top($post_view) + $post_view.outerHeight() * 0.69 - post_view_child('.article--footer').outerHeight() - multipage_loader_height - 10;
          if (post_view_child('.article--multipage-loader').length) {
            position_load_pagination = theme_get_offset_top(post_view_child('.article--multipage-loader')) - 10;
          }

          position_load_feed = theme_get_offset_top($post_view) + $post_view.outerHeight() * 0.34 - post_view_child('.article--footer').outerHeight() - 10;
          if (post_view_child('.article--page').length) {
            position_load_feed = theme_get_offset_top(post_view_child('.article--page')) - 10;
          }
          if (post_view_child('.article--footer').length) {
            position_load_next_post = theme_get_offset_top(post_view_child('.article--footer')) - 10;
          }          
          
          /* change title && change url */
          if (typeof post_info[post_viewing] !== 'undefined') {
            var viewing_text_entry = ("Viewing: " + post_info[post_viewing].title.cleared);
            var infos_article = true;
            
            /* If is PAGINATED POST */
            if (null !== viewing_text && post_view_child('.article--multipage').find('.multipage--post').length && post_info[post_viewing].multipage && typeof post_info[post_viewing].content === 'object') {

              if (singleOffsetTop >= theme_get_offset_top(post_view_child('.article--multipage'))) {
                var plink = post_info[post_viewing].link.pagination;
                post_view_child('.article--multipage').find('.multipage--post').each(function() {
                  var $post_multipage = jQuery(this);
                  var page_number = parseInt($post_multipage.attr('page_number'));
                  var post_viewing_page = parseInt($post_view.attr('data-page')) + 1;
                  var condition=singleOffsetTop >= (theme_get_offset_top($post_multipage) - 10);
                  if(page_number!==post_viewing_page){
                    condition=(singleOffsetTop >= (theme_get_offset_top($post_multipage) - 10) && singleOffsetTop <= (theme_get_offset_top($post_multipage) + $post_multipage.outerHeight() + 10));
                  }
                  if (condition) {

                    infos_article = false;
                    var document_title = post_info[post_viewing].title.document.multipage.replace("_PAGE_", page_number).replace("_TOTPAGE_", $post_view.data('pagetot'));
                    viewing_text_entry = ("Viewing: " + post_info[post_viewing].title.cleared + " - Pagina " + page_number);
                    viewing_text = viewing_text_entry;

                    theme_change_article(document_title,plink.replace("_PAGE_", page_number),true);
                    return false;
                  }
                });
              }

            }
            if (viewing_text !== viewing_text_entry) {
              
              common_theme_single();

              // is_changed_article = false;
              var document_title = post_info[post_viewing].title.document.cleared;
              if (infos_article && document.title !== document_title) {
                viewing_text = viewing_text_entry;
                theme_change_article(document_title,post_info[post_viewing].link.multipage,false);
                is_scrolling_to_prev_post = false;
                is_scrolling_to_next_post = false;
              } else if (null === viewing_text) {
                viewing_text = viewing_text_entry;
                console.log(viewing_text);
              }

              $themeWin.trigger("resize");
            }
            return false;
          }

          return false;
        }
      });
    } /* understand what article are you viewing */
   
    function theme_infinite_loop() {
      if (get_post_info) {

        if(isNaN(post_viewing)){ post_viewing=0;}

        if(!(post_viewing in appending_pagination)){
          appending_pagination[post_viewing]=false;
        }
        if(!(post_viewing in post_pagination_end)){
          post_pagination_end[post_viewing]=true;
        }
        if(!(post_viewing in read_more_opened)){
          read_more_opened[post_viewing]=false;
        }
      }
    }

    function theme_append_next_page(){
      if (false !== is_scrolling_to_prev_post || !position_load_pagination || !position_load_feed || !position_load_next_post || typeof post_info[post_viewing] === 'undefined') { return false; }

      theme_infinite_loop();

      if ((!theme_is_mobile() || (theme_is_mobile() && read_more_opened[post_viewing])) && POST.infinite_loops_single_pagination && singleOffsetBottom >= position_load_pagination && !appending_pagination[post_viewing] && theme_has_class($post_view,"article--multipage__true")) {

        post_pagination_end[post_viewing] = false;
        if ((parseInt($post_view.attr('data-page')) + 1) === parseInt($post_view.attr('data-pagetot'))) {
          // alert('finita pagination');
          post_pagination_end[post_viewing] = true;
          appending_pagination[post_viewing] = false;
          $post_view.removeClass('article--multipage__true');
          post_view_child('.article--multipage-loader').fadeOut();
        } else {
          // alert('add pagination');
          if (typeof post_info[post_viewing].content === 'object') {

            var page_next = parseInt($post_view.attr('data-page')) + 1;
            var pagetot = parseInt($post_view.attr('data-pagetot'));
            var postnumber = parseInt($post_view.attr('postnumber'));
            var class_multipage_post = 'post_multipage_' + post_info[post_viewing].id + '_' + page_next;
            post_view_child('.article--multipage').append("<div style='display:none' class='multipage--post block--container block--container__sidebar " + class_multipage_post + "' page_number='" + (page_next + 1) + "'></div>");

            // post_view_child('.article--multipage').find('.'+class_multipage_post).append(post_info[post_viewing-1].content_pagination[page_next]);
            post_view_child('.article--multipage').find('.' + class_multipage_post).append(post_info[post_viewing].content[page_next]);
            appending_pagination[post_viewing] = true;
            post_view_child('.article--multipage').find('.' + class_multipage_post)
              .show();

            add_ads_theme_single(post_view_child('.article--multipage').find('.' + class_multipage_post).find('.inner-article.add'),null);

            theme_resize_video();
            on_ref_replace();

            if (page_next > 0 || !theme_is_mobile()) {
              theme_ads_medium_rectangle_up(post_view_child('.article--multipage').find('.' + class_multipage_post).find('.sticky--element .theme-adv'));
            }

            if ((page_next + 1) < pagetot) {
              post_view_child('.article--multipage-loader').show();
            } else {
              post_view_child('.article--multipage-loader').fadeOut();
            }


            try { setTimeout(iframe_resize_fb,2000); } catch (err) { }

            theme_status_lazy_load();
            setTimeout(function() {
              appending_pagination[post_viewing] = false;
              $themeWin.trigger("scroll");
            }, 1000);
            $post_view.attr('data-page', page_next).data('page', page_next);

            // Listicles
            try { 
              if (typeof mp_listicles_set_vote_button === 'function') {
                mp_listicles_set_vote_button();
              }
             } catch (err) { }

          } else {
            // alert('finita nuovamente pagination');
            post_pagination_end[post_viewing] = true;
            appending_pagination[post_viewing] = false;
            $post_view.removeClass('article--multipage__true');
            post_view_child('.article--multipage-loader').fadeOut();
          }

        }

        /* check if is scrolling by class .scroll_to*/
        if (false !== is_scrolling_to) {
          is_scrolling_to.trigger('click');
        }
        if (false !== is_scrolling_to_next_post) {
          theme_scroll_to_next_article(false);
        }

      }
    } /* append next page on multipage post if enabled */

    function theme_append_next_post() {
      if (false !== is_scrolling_to_prev_post || !position_load_pagination || !position_load_feed || !position_load_next_post || typeof post_info[post_viewing] === 'undefined') { return false; }
      theme_infinite_loop();

      if (POST.infinite_loops_single_next && theme_has_class($post_view,"article--last")) {
        
        if (((post_pagination_end[post_viewing] && !theme_is_mobile()) || theme_is_mobile()) && singleOffsetBottom >= position_load_next_post) {
          post_view_child('.article--multipage-loader').fadeOut();
          jQuery('.article--last').addClass('next-article--loading');
          jQuery('.article--last.next-article--loading').find('.article--footer').css('padding-bottom', '');

          if (post_showed < post_info.length) {
            // appending_article = true;
            if (((post_showed+1) in post_info) && !theme_has_class($themeMain.find('article.article--single'),'is-post-' + post_info[post_showed+1].id) && jQuery.inArray(post_info[post_showed+1].id, post_already_showed) === -1) {

              post_showed=post_showed+1;
              console.log('Post appended correctly: ' + post_info[post_showed].title.cleared);
              $themeMain.append(decodeHtml(post_info[post_showed].post_html)).text();
              $themeMain.find('article').removeClass('article--last').removeClass('next-article--loading');
              var $appended_article = $themeMain.find('article.article--single.post-' + post_info[post_showed].id);
              $appended_article
                .hide()
                .addClass('is-post-' + post_info[post_showed].id)
                .addClass('article--last')
                .addClass('article--next')
                .attr('postnumber', post_showed);
              post_already_showed.push(post_info[post_showed].id);

              //ADS
              theme_ads_medium_rectangle_up($themeMain.find('article.post-' + post_info[post_showed].id).find('.article--page').find('.sidebar--other .theme-adv'));

              $themeMain.find('article.post-' + post_info[post_showed].id).find('.article--content').find('p').eq(1).after('<div class="banner_premium_native_js"></div>');
              theme_ads_premium_native($themeMain.find('article.post-' + post_info[post_showed].id).find('.article--content').find('.banner_premium_native_js'));
              
              var page_tot = $themeMain.find('article.post-' + post_info[post_showed].id).attr('data-pagetot');
              if (!theme_is_mobile()) {
                theme_ads_medium_rectangle_dw($themeMain.find('article.post-' + post_info[post_showed].id + ' .sidebar .theme-adv'));
              } else {
                theme_ads_medium_rectangle_dw($themeMain.find('article.post-' + post_info[post_showed].id + ' .article--content--adv .theme-adv'));
              }

              var id_banner = "div-banner-ad-" + post_info[post_showed].id;
              $appended_article .prepend("<div id='" + id_banner + "' class=\"row banner-theme-post\"></div>").text();
              theme_ads_post_header_leaderboard(jQuery('#' + id_banner));

              add_ads_theme_single($appended_article.find('.inner-article.add'), $appended_article.find('.theme-adv.af'));

              theme_resize_video();
              on_ref_replace();

              $themeMain.find('article.article--single.is-post-' + post_info[post_showed].id).show();
              reload_fb($themeMain.find('article.article--single.is-post-' + post_info[post_showed].id).find('#box-comments-' + post_info[post_showed].id)[0]);
              
              // height_half_width();
              // height_same_width();
              theme_status_lazy_load();

              if (false !== is_scrolling_to_next_post) {
                theme_scroll_to_next_article(false);
              }

            } else if((post_showed+1) in post_info){
              // alert('Post already exists: ' + post_info[post_showed].title.cleared);
              console.log('Post already exists: ' + post_info[post_viewing].title.cleared);
              post_showed=post_showed+1;
              // appending_pagination[post_viewing + 1]=false;
              // post_pagination_end[post_viewing + 1]=true;
              // read_more_opened[post_viewing + 1]=false;
              $themeWin.trigger("scroll");
            }
            // appending_article = false;
          } else {
            jQuery('.article--last.next-article--loading').find('.loader_next_post').fadeOut(1000);
          }
        }

      }
    } /* append next post if enabled */

    function theme_get_next_feed(){
      if (POST.infinite_loops_single_next && theme_has_class($post_view,"article--last")) {
        if (feed_urls && post_showed >= (post_info.length - 2) && !get_feed_posts_info_ajax && singleOffsetBottom >= position_load_feed) {
          var url = feed_urls.shift();
          if ('undefined' !== typeof url) {
            console.log("Get feed post: " + url);
            get_feed_posts_info_ajax = true;
            jQuery.ajax({
              type: "GET",
              url: url,
              dataType: "json",
              async: true,
              success: function(response) {
                jQuery.each(response, function(i, item) {
                  post_info.push(item);
                });
                console.log('Get feed posts successfully: ' + url);
              },
              error: function(t, a) {
                console.log('Error: get feed posts: ' + url);
              },
              complete: function() {
                get_feed_posts_info_ajax = false;
                $themeWin.trigger("scroll");
              }
            });
          }
        }
      }
    } /* return next feed */

    function theme_get_post_infos() {
      if (POST.infinite_loops_single_next || POST.infinite_loops_single_pagination) {
        if (!get_post_info && !get_post_info_ajax) {
          var scrollPosDocument = themeDocTop;
          var mainDocument = theme_get_offset_top($themeMain) + ($themeMain.outerHeight() * 18 / 100);
          if (scrollPosDocument > mainDocument) {
            console.log("Get post infos ...");
            get_post_info_ajax = true;
            jQuery.ajax({
              type: "GET",
              url: POST.get_infos,
              dataType: "json",
              async: true,
              success: function(response) {
                post_info[0] = response;
                feed_urls = response.ajax_urls;
                post_already_showed[0] = response.id;
                get_post_info = true;
                theme_infinite_loop();
                $themeMain.find('article').removeClass('article--last').removeClass('next-article--loading');
                $themeMain.find('article.post-' + response.id)
                  .addClass('is-post-' + post_info[0].id)
                  .addClass('article--last')
                  .attr('postnumber', 0);
                console.log("... Success");
                theme_get_next_feed();
                $themeWin.trigger("scroll");
              },
              error: function(t, a) {
                console.log('... Error');
                failed = failed + 1;
              },
              complete: function() {
                if (!get_post_info && failed < 5) {
                  get_post_info_ajax = false; 
                }
              }
            });
          }
        }
      }
    } /* return post infos */

    function infinite_is_enabled(){
      return (POST.infinite_enabled && !WP_IS_PREVIEW);
    }


    function click_read_more_article_content(e) {
      e.preventDefault();
      e.stopPropagation();
      var _btn_hide=jQuery(this).data('hide');
      jQuery(_btn_hide)
        .removeClass('article--content--read-more')
        .removeClass('article--multiple--read-more');
      if(isNaN(post_viewing)){ post_viewing=0; }
      theme_infinite_loop();
      if(isNaN(post_viewing)){ post_viewing=0; }
      read_more_opened[post_viewing]=true;
      remove_sticky_styles();
      theme_status_lazy_load();
      $themeWin.trigger("resize").trigger("scroll");
      if (infinite_is_enabled()) {
        theme_append_next_page(); /* ADD NEXT PAGE POST */
      }
    } /* click on read more */

  /* ==========================================================================================================
  ===  EVENTS  ================================================================================================
  ============================================================================================================= */

  /* == DOCUMENT READY ======================================================================================== */
    init_theme_single($themeMain.find('article.article--last')); /* === SET POST VIEW === */
    strip_bar__progress(); /* === CONTENT === */
    theme_elaborate_article(); /* === CONTENT === */
    if (infinite_is_enabled()) { 
      theme_get_post_infos();
      theme_append_next_page(); /* ADD NEXT PAGE POST */
      theme_append_next_post(); /* ADD NEXT POST */
    }
    
  /* == DOCUMENT READY END ==================================================================================== */
  
  /* == WINDOW RESIZE ========================================================================================= */
    $themeWin.resize(function() {
      strip_bar__progress(); /* === CONTENT === */
      theme_elaborate_article(); /* === CONTENT === */
      
      if (infinite_is_enabled()) { 
        theme_get_post_infos();
        theme_get_next_feed();
        theme_append_next_page(); /* ADD NEXT PAGE POST */
        theme_append_next_post(); /* ADD NEXT POST */
      }
      
    });
  /* == WINDOW RESIZE END ===================================================================================== */

  /* == WINDOW SCROLL ========================================================================================= */
    $themeWin.scroll(function() {
      strip_bar__progress(); /* === CONTENT === */
      theme_elaborate_article(); /* === CONTENT === */
      if (infinite_is_enabled()) { 
        theme_get_post_infos();
        theme_get_next_feed();
        theme_append_next_page(); /* ADD NEXT PAGE POST */
        theme_append_next_post(); /* ADD NEXT POST */
      }
    });
  /* == WINDOW SCROLL END ===================================================================================== */

  /* == DOCUMENT CLICK ======================================================================================== */
    $themeDoc.on('click', '.cta--next', click_cta_next); /* === Scroll to next/prev post === */
    $themeDoc.on('click', '.cta--prev', click_cta_prev); /* === Scroll to next/prev post === */
    $themeDoc.on('click', '.show--area--img.is_infinite_loop .show--area_next', click_cta_next); /* === Scroll to next/prev post === */
    $themeDoc.on('click', '.show--area--img.is_infinite_loop .show--area_prev', click_cta_prev); /* === Scroll to next/prev post === */
    $themeDoc.on('click', '.article--content--read-more__btn',click_read_more_article_content); /* === CONTENT === */

  /* == DOCUMENT CLICK END ==================================================================================== */

  /* ==========================================================================================================
  ===  EVENTS END =============================================================================================
  ============================================================================================================= */

  }
};
